<template>
    <div
        class="col-12 algolia-listing-product-block__product-options-wrapper--mobile"
    >
        <div
            class="row algolia-listing-product-block__select-item-wrapper"
            v-for="(combination, index) in validCombinationsComputed"
            :class="[combination.id_combination === selectedCombination?.id_combination ? 'algolia-listing-product-block__select-item-wrapper--active' : 'algolia-listing-product-block__select-item-wrapper--unactive',
             index === validCombinationsComputed.length - 1 ? 'algolia-listing-product-block__select-item-wrapper--last' : '']"
        >
            <div class="col-12" @click="handleSelectedCombination(combination)">
                <div
                    class="row algolia-listing-product-block__product-option-content-wrapper--mobile d-flex align-items-center"
                >
                    <div
                        class="col-12 algolia-listing-product-block__product-option-item-wrapper mb-1"
                    >
                        <div
                            class="algolia-listing-product-block__product-option-item algolia-listing-product-block__product-option-item--mobile"
                            :class="{
                                'algolia-listing-product-block__product-option-item--unavailable': hasUnavailableStatus(combination)
                            }"
                        >
                            <div class="row">
                                <div
                                    class="col-4 algolia-listing-product-block__product-amount-wrapper"
                                >
                                    <div>
                                        <div
                                            class="algolia-listing-product-block__product-amount"
                                        >
                                            <section class="d-flex flex-column">
                                                <section class="d-flex flex-row">
                                                    <span class="algolia-listing-product-block__product-amount-span" :title="combination.attribute_name">{{ truncate(combination.attribute_name , 24) }} </span>
                                                    <div class="algolia-listing-product-block__mobile-tooltip-button"
                                                         @click="openTooltip(index)"
                                                         v-if="truncate(combination.attribute_name, 24) !== combination.attribute_name"
                                                    >
                                                        <i class="fal fa-info-circle"></i>
                                                    </div>
                                                </section>
                                                <product-combination-promotion-text
                                                    v-if="combination.attribute_promotion_name"
                                                    :name="combination.attribute_promotion_name"
                                                />
                                            </section>
                                            <div v-if="tooltipIsOpen[index]" class="algolia-listing-product-block__mobile-tooltip">
                                                <div class="d-flex justify-content-between mb-1">
                                                    <span class="mt-1" v-text="combination.attribute_name"></span>
                                                    <div class="algolia-listing-product-block__mobile-tooltip-close-button" @click="openTooltip(index)">
                                                        <i class="fas fa-times-circle"></i>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-6 px-0">
                                    <PricingReduction
                                            v-if="
                                            combination.price_reduction &&
                                                combination.available_now
                                        "
                                            :combination="combination"
                                    />
                                    <PricingNormal
                                            v-else-if="
                                            combination.available_now &&
                                                !hasUnavailableStatus(
                                                    combination
                                                ) &&
                                                !combination.bundle_discount_formatted
                                        "
                                            :combination="combination"
                                    />
                                    <PricingDiscount
                                            v-else-if="combination.available_now && !hasUnavailableStatus(combination) && combination.bundle_discount_formatted"
                                            :combination="combination"
                                    />
                                    <PricingNotAvailable
                                            v-else
                                            :lang-iso="langIso"
                                            :combination="combination"
                                    />
                                </div>
                                <div class="col-2 d-flex align-items-center justify-content-center">
                                    <div class="col-1 pl-0 pl-md-1 pl-lg-3 d-flex align-items-center algolia-listing-product-block__radio-button-wrapper">
                                        <div class="algolia-listing-product-block__radio-button">
                                            <input
                                                type="radio"
                                                name="product_selection"
                                                :checked="selectedCombination?.id_combination === combination.id_combination"
                                            >
                                            <span class="algolia-listing-product-block__radio-button-checkmark"></span>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import PricingReduction from "./Pricing/PricingReduction.vue";
import PricingNormal from "./Pricing/PricingNormal.vue";
import PricingNotAvailable from "./Pricing/PricingNotAvailable.vue";
import PricingDiscount from "./Pricing/PricingDiscount.vue";
import ProductCombinationPromotionText from "./ProductCombinationPromotionText.vue";

export default {
    components: {
        PricingReduction,
        PricingNotAvailable,
        PricingNormal,
        PricingDiscount,
        ProductCombinationPromotionText
    },
    props: {
        combinations: {
            type: Array,
            required: true
        },
        idProduct: {
            type: Number,
            required: true
        },
        queryId: {
            type: [String, Number],
            required: true
        },
        objectId: {
            type: String,
            required: true,
        },
        position: {
            type: [String, Number],
            required: true
        },
        linkToCart: {
            type: String,
            required: true
        },
        langIso: {
            type: String,
            required: false,
            default: "nl-NL"
        }
    },
    data() {
        return {
            selectedCombination: null,
            tooltipIsOpen: [],
        };
    },
    methods: {
        formattedAvailableDate: availableDate => {
            // ToDO: Send the correct formatter.
            return new Date(availableDate);
        },
        toggleModal() {
            $(`#product_search_modal_${this.idProduct}`).modal('toggle');
        },
        handleOutOfStock(combination) {
            this.$emit("out-of-stock");
            this.toggleModal();
            $("#out-of-stock-opt-in-modal").removeClass("d-none");
            $("#out-of-stock-optin-attribute").val(combination.id_product_attribute);
        },
        handleSelectedCombination(combination) {
            this.$emit("selected-combination", combination);
            this.selectedCombination = combination;
        },
        hasUnavailableStatus(combination) {
            return (
                !combination.available_now ||
                combination.unavailable_status_text
            );
        },
        openTooltip(index){
            this.tooltipIsOpen[index] = !this.tooltipIsOpen[index];
        },
        truncate(data,num){
            if (! data) {
                return '';
            }
            let truncatedString = data.split("").slice(0, num).join("");

            if (truncatedString !== data) {
                truncatedString += '...';
            }

            return truncatedString;
        }
    },
    computed: {
        isValidProductSelection() {
            return true;
        },
        validCombinationsComputed() {
            if (!this.combinations) {
                return this.combinations;
            }

            let combinationsObject = this.combinations;

            Object.entries(combinationsObject).map(([id, item]) => {
                combinationsObject[id].id_combination = parseInt(id);

                return item;
            });

            return combinationsObject;
        }
    }
};
</script>
